export const PROFILE_IMAGE_PATH = '/images/profile/'

export const MAX_PROFILE_SECTION_ITEMS_COUNT = 6
